import React, { useState, useRef, useMemo, useEffect } from "react";
import html2canvas from "html2canvas";
import axios from "axios";
import { collection, query, where, getDocs } from "firebase/firestore";
import { productDb } from "../firebaseProducts";
import ResizableImage2 from "./ResizableComponent2";
import tags from "./tags.json";

const MockupUploader = () => {
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [overlayImage, setOverlayImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [cloudinaryUrl, setCloudinaryUrl] = useState(null);

  const [images, setImages] = useState([]);
  const [category, setCategory] = useState("adult");
  const mockupRef = useRef(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const [selectedThumbnailMain, setSelectedThumbnailMain] = useState("");
  const [ActualId, setIDval] = useState("");
  const [selectedThumbnailId, setSelectedThumbnailId] = useState("");
  // Style & colors
  const [styleNumber, setStyleNumber] = useState("");
  const [availableColors, setAvailableColors] = useState([]);
  const [colorFrontModelMap, setColorFrontModelMap] = useState({});
  const [selectedColor, setSelectedColor] = useState("");

  // Load design thumbnails
  useEffect(() => {
    const loadImages = async () => {
      try {
        const module =
          category === "kids"
            ? await import("./ax2.js")
            : await import("./axAdult.js");
        setImages(module.images || []);
      } catch (err) {
        console.error("Failed to load images:", err);
      }
    };
    loadImages();
  }, [category]);

  const handleBackgroundUpload = (e) => {
    const file = e.target.files[0];
    if (file) setBackgroundImage(URL.createObjectURL(file));
  };

  // Debounced search query
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedQuery(searchQuery), 200);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleOverlayUpload = (e) => {
    const file = e.target.files[0];
    if (file) setOverlayImage(URL.createObjectURL(file));
  };

  // const handleUploadToCloudinary = async () => {
  //   if (!mockupRef.current) return;
  //   if (!backgroundImage) return alert("No background image selected");

  //   setUploading(true);

  //   try {
  //     // 1️⃣ Get proxied image from your backend (fixes CORS)
  //     const response = await fetch(
  //       "https://api-shipping-28612190fdf4.herokuapp.com/image",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           imageUrl: backgroundImage,
  //         }),
  //       },
  //     );

  //     const data = await response.json();

  //     if (!data.image) {
  //       throw new Error("Proxy did not return image");
  //     }

  //     // 2️⃣ Apply proxied image as background
  //     const element = mockupRef.current;
  //     // element.style.backgroundImage = `url(${data.image})`;

  //     // 3️⃣ Wait until background image is fully loaded
  //     await new Promise((resolve) => {
  //       const img = new Image();
  //       img.crossOrigin = "anonymous";
  //       img.src = data.image;
  //       img.onload = resolve;
  //     });

  //     // 4️⃣ Capture with html2canvas
  //     const canvas = await html2canvas(element, {
  //       useCORS: true,
  //       allowTaint: false,
  //       scale: 2,
  //       backgroundColor: null,
  //     });

  //     const blob = await new Promise((resolve) =>
  //       canvas.toBlob(resolve, "image/png"),
  //     );

  //     if (!blob) throw new Error("Canvas blob failed");

  //     // 5️⃣ Upload to Cloudinary
  //     const formData = new FormData();
  //     formData.append("file", blob);
  //     formData.append("upload_preset", "my_insta");

  //     const cloudRes = await axios.post(
  //       "https://api.cloudinary.com/v1_1/dcuturlmb/image/upload",
  //       formData,
  //     );

  //     setCloudinaryUrl(cloudRes.data.secure_url);

  //     console.log("Upload success:", cloudRes.data.secure_url);
  //   } catch (error) {
  //     console.error("Capture/Upload failed:", error);
  //     alert("Upload failed");
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  // Memoized filtered images
  const handleUploadToCloudinary = async () => {
    if (!mockupRef.current) return;
    if (!backgroundImage) return alert("No background image selected");

    setUploading(true);

    const originalBackground = backgroundImage; // save current

    try {
      // 1️⃣ Get proxied image from your backend
      const response = await fetch(
        "https://api-shipping-28612190fdf4.herokuapp.com/image",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            imageUrl: backgroundImage,
          }),
        },
      );

      const data = await response.json();
      if (!data.image) throw new Error("Proxy did not return image");

      // 2️⃣ TEMPORARILY replace background with proxied version
      setBackgroundImage(data.image);

      // 3️⃣ Wait for React to update DOM
      await new Promise((resolve) => setTimeout(resolve, 200));

      const element = mockupRef.current;

      // 4️⃣ Wait for ALL images inside container
      const images = element.querySelectorAll("img");

      await Promise.all(
        Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }),
      );

      // 5️⃣ Capture
      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: false,
        scale: 2,
        backgroundColor: null,
      });

      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png"),
      );

      if (!blob) throw new Error("Canvas blob failed");

      // 6️⃣ Upload to Cloudinary
      const formData = new FormData();
      formData.append("file", blob);
      formData.append("upload_preset", "my_insta");

      const cloudRes = await axios.post(
        "https://api.cloudinary.com/v1_1/dcuturlmb/image/upload",
        formData,
      );

      setCloudinaryUrl(cloudRes.data.secure_url);
      // console.log("Upload success:", cloudRes.data.secure_url);
    } catch (error) {
      console.error("Capture/Upload failed:", error);
      alert("Upload failed");
    } finally {
      // 7️⃣ Restore original background
      setBackgroundImage(originalBackground);
      setUploading(false);
    }
  };
  // const filteredImages = useMemo(() => {
  //   const words = debouncedQuery.trim().toLowerCase().split(/\s+/);
  //   if (!words[0]) return images;

  //   return images.filter((image) => {
  //     const normalizedSrc = (image.main || image.id)
  //       ?.split("/")
  //       .pop()
  //       .replace(/\.[^/.]+$/, "")
  //       .replace(/-/g, " ")
  //       .toLowerCase();

  //    const normalizedId = String(image.id || "")
  // .replace(/[^a-z0-9]/gi, " ") // remove symbols like & and -
  // .toLowerCase();
  //     return words.every(
  //       (word) => normalizedSrc?.includes(word) || normalizedId === word,
  //     );
  //   });
  // }, [images, debouncedQuery]);
  const filteredImages = useMemo(() => {
    const words = debouncedQuery.trim().toLowerCase().split(/\s+/);
    if (!words[0]) return images;

    return images.filter((image) => {
      const normalizedSrc = (image.main || image.id || "")
        .split("/")
        .pop()
        .replace(/\.[^/.]+$/, "")
        .replace(/-/g, " ")
        .toLowerCase();

      const normalizedId = String(image.id || "")
        .replace(/[^a-z0-9]/gi, " ")
        .toLowerCase();

      return words.every(
        (word) => normalizedSrc.includes(word) || normalizedId.includes(word),
      );
    });
  }, [images, debouncedQuery]);
  const handleSearchChange = (e) => setSearchQuery(e.target.value);
  const handleThumbnailClick = (image) => {
    setOverlayImage(image.src || image.main);
    setSelectedThumbnailId(image.id || image.main);
    setSelectedThumbnailMain(image.main || "");
    setIDval(image.id);
  };

  // ------------------ STYLE / COLOR HANDLING ------------------
  const handleStyleNumberChange = (e) => {
    setStyleNumber(e.target.value);
    setAvailableColors([]);
    setSelectedColor("");
    setBackgroundImage(null);
    setColorFrontModelMap({});
  };

  const fetchColorsForStyle = async () => {
    if (!styleNumber.trim()) return alert("Enter a style number");

    const collectionName =
      category === "kids" ? "kids-apparel" : "adult-apparel";

    try {
      const styleValue = styleNumber.trim().toUpperCase();
      const q = query(
        collection(productDb, collectionName),
        where("Style", "==", styleValue),
      );
      const snap = await getDocs(q);

      if (snap.empty) return alert("Style not found");

      const colorMap = {};
      snap.docs.forEach((doc) => {
        const data = doc.data();
        if (data.Color && data.FRONT_MODEL) {
          // colorMap[data.Color] = data.FRONT_FLAT || data.FRONT_MODEL;
          colorMap[data.Color] = data.FRONT_MODEL;
          colorMap[`${data.Color}_circle`] = data.ImageCircle || null;
        }
      });

      const colors = Object.keys(colorMap).filter(
        (k) => !k.endsWith("_circle"),
      );
      if (colors.length === 0) return alert("No colors found for this style");

      setAvailableColors(colors);
      setColorFrontModelMap(colorMap);
      setSelectedColor(colors[0]);
      setBackgroundImage(colorMap[colors[0]]);
    } catch (err) {
      console.error("Firestore fetch error:", err);
      alert("Failed to fetch style colors");
    }
  };

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    if (colorFrontModelMap[color])
      setBackgroundImage(colorFrontModelMap[color]);
  };
  const downloadCSV = async () => {
    if (!styleNumber.trim() || !selectedColor) {
      return alert("Please select a style number and color first");
    }

    const collectionName =
      category === "kids" ? "kids-apparel" : "adult-apparel";

    try {
      //       console.log("STYLE ENTERED:", styleNumber);
      // console.log("STYLE USED:", styleNumber.trim().toUpperCase());
      // console.log("SELECTED COLOR:", selectedColor);
      // console.log("COLLECTION:", collectionName);
      const q = query(
        collection(productDb, collectionName),
        where("Style", "==", styleNumber.trim().toUpperCase()),
        where("Color", "==", selectedColor),
      );

      const snap = await getDocs(q);
      if (snap.empty) return alert("No items found.");

      // ✅ Desired CSV column order
      const headers = [
        "id",
        "backImage",
        "SALE_START_DATE",
        "Price",
        "endSale",
        "piece_cost",
        "VariantGrams",
        "Title",
        "ImageAltText",
        "AVAILABLE_SIZES",
        "salePrice",
        "frontImage",
        "measure_asli",
        "Tags",
        "Body",
        "PieceCost",
        "VariantImage",
        "side",
        "Color",
        "PRODUCT_MEASUREMENTS",
        "Style",
        "colorName4API",
        "DECORATION_SPEC_SHEET",
        "Size",
        "ImageCircle",
        "ImageID",
        "mainPath",
        "Status",
        "Type",
        "createdAt",
        "source",
        "variantId",
        "vendorSku"
      ];

      // Helper: return first non-null value
      const firstValid = (...values) => {
        for (let v of values) {
          if (v !== null && v !== undefined && v !== "") return v;
        }
        return "";
      };
      // 🔥 1️⃣ Tags from selected thumbnail path
const thumbnailTags = selectedThumbnailMain
  ? selectedThumbnailMain
      .replace(/[\/\\:\.\-_]/g, ",") // replace / \ : . - _ with space
      .split(",")                     // split by space
      .map(t => t.trim())
      .filter(Boolean)
  : [];
// console.log("Tags from thumbnail:", thumbnailTags);
      // 🔥 2️⃣ Tags from JSON file
      const externalTagsMap = tags;
      const matchedStyle = externalTagsMap.find(
        (item) => item.Style === styleNumber.trim(),
      );

      const jsonTags = matchedStyle?.Tags || [];
// console.log("Tags from JSON for style", styleNumber, ":", jsonTags);
      // 🔥 3️⃣ Merge + remove duplicates
const mergedTags = Array.from(new Set([...thumbnailTags, ...jsonTags]));
// console.log("Merged tags:", mergedTags);

      // ✅ Final comma-separated string
      const finalTags = mergedTags.join(",");
      // console.log("Final CSV tags string:", finalTags);
      const uniqueRows = new Set();

      snap.docs.forEach((doc) => {
        const d = doc.data();
        // Removes weird special characters, keeps letters, numbers, punctuation
        const cleanText = (text) => {
          if (!text) return "";
          return text
            .normalize("NFKD") // Normalize Unicode
            .replace(/[^\x20-\x7E]/g, "") // Keep only standard ASCII characters
            .trim();
        };

        const rowObject = {
          id: d.id || "",
          backImage: firstValid(d.BACK_MODEL, d.BACK_FLAT, d.VariantImage, d.back),
          SALE_START_DATE: d.SALE_START_DATE || "",
          Price: d.Price || "",
          endSale: d.endSale || "",
          // piece_cost: d.PieceCost || "",
          VariantGrams: firstValid(d.Weight, d.VariantGrams),
          Title: cleanText(d.Title),
          ImageAltText: cleanText(d.ImageAltText),
          AVAILABLE_SIZES: d.AVAILABLE_SIZES || "",
          salePrice: d.salePrice || "",
          frontImage:
            cloudinaryUrl ||
            // firstValid(d.FRONT_FLAT, d.model, d.FRONT_MODEL, d.front),
            firstValid(d.FRONT_MODEL, d.model),
          measure_asli: d.measure_asli || "",
          Tags: mergedTags,
          Body: cleanText(d.Body),
          PieceCost: d.PieceCost || "",
          // VariantImage: firstValid(d.ImageSrc, d.FRONT_FLAT),
          VariantImage: firstValid(d.FRONT_MODEL, d.model),
          side: d.side || "",
          Color: d.Color || "",
          PRODUCT_MEASUREMENTS: d.PRODUCT_MEASUREMENTS || "",
          Style: d.Style,
          colorName4API: d.colorName4API || "",
          DECORATION_SPEC_SHEET: d.DECORATION_SPEC_SHEET || "",
          Size: d.Size || "",
          ImageCircle: d.ImageCircle || "",
          ImageID: selectedThumbnailId,
          mainPath: selectedThumbnailMain,
          Status: "In Stock",
          Type: `id: ${d.id}`,
          createdAt: null,
          source: null,
          variantId: null,
          vendorSku: null

        };

        const row = headers
          .map((key) => `"${String(rowObject[key] ?? "").replace(/"/g, '""')}"`)
          .join(",");

        uniqueRows.add(row); // ✅ removes duplicates automatically
      });

      const csvContent =
        headers.join(",") + "\r\n" + Array.from(uniqueRows).join("\r\n");

      const blob = new Blob(["\uFEFF" + csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Style_${styleNumber}_${selectedColor}_${ActualId}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("CSV export error:", err);
      alert("Failed to generate CSV");
    }
  };
  return (
    <div style={{ padding: 20, maxWidth: 1200, margin: "0 auto" }}>
      <h2>Mockup Uploader</h2>

      {/* Category selector */}
      <div
        style={{ marginBottom: 20, display: "flex", flexWrap: "wrap", gap: 10 }}
      >
        <label>Select Category:</label>
        <select
          value={category}
          onChange={(e) => {
            setCategory(e.target.value);
            setOverlayImage(null);
            setAvailableColors([]);
            setSelectedColor("");
            setBackgroundImage(null);
            setStyleNumber("");
            setColorFrontModelMap({});
          }}
          style={{
            padding: "6px 12px",
            borderRadius: 5,
            border: "1px solid #ccc",
          }}
        >
          <option value="adult">Adult</option>
          <option value="kids">Kids</option>
        </select>
      </div>

      {/* Style number input */}
      <div
        style={{ marginBottom: 20, display: "flex", flexWrap: "wrap", gap: 10 }}
      >
        <label>Enter Style Number: </label>
        <input
          type="text"
          value={styleNumber}
          onChange={handleStyleNumberChange}
          placeholder="e.g., 3000"
          style={{
            padding: "6px 10px",
            borderRadius: 4,
            flex: 1,
            minWidth: 150,
          }}
        />
        <button
          onClick={fetchColorsForStyle}
          style={{
            padding: "6px 12px",
            borderRadius: 5,
            border: "1px solid #007bff",
            backgroundColor: "#007bff",
            color: "white",
            cursor: "pointer",
          }}
        >
          Get Colors
        </button>
      </div>

      {/* Color swatches */}
      {availableColors.length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <label>Select Color: </label>
          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
              marginTop: 5,
            }}
          >
            {availableColors.map((color) => {
              const swatchUrl = colorFrontModelMap[`${color}_circle`] || null;
              return (
                <button
                  key={color}
                  onClick={() => handleColorSelect(color)}
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: 5,
                    border:
                      selectedColor === color
                        ? "2px solid #007bff"
                        : "1px solid #ccc",
                    backgroundColor: "#fff",
                    backgroundImage: swatchUrl ? `url(${swatchUrl})` : "none",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    cursor: "pointer",
                  }}
                  title={color}
                >
                  {!swatchUrl && color}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Background upload */}
      <div style={{ marginBottom: 20 }}>
        <label>Upload Background Image: </label>
        <input type="file" accept="image/*" onChange={handleBackgroundUpload} />
      </div>

      {/* Overlay upload */}
      <div style={{ marginBottom: 20 }}>
        <label>Upload Overlay Image (Design): </label>
        <input type="file" accept="image/*" onChange={handleOverlayUpload} />
      </div>

      {/* Design thumbnails & search */}
      <div style={{ width: "100%", marginBottom: 20 }}>
        <div style={{ textAlign: "center", marginBottom: 10 }}>
          <h5 style={{ color: "navy" }}>
            Available designs:{" "}
            <span style={{ fontSize: 14 }}>({filteredImages.length})</span>
          </h5>
        </div>

        <div className="search-box" style={{ marginBottom: 10 }}>
          <input
            type="text"
            placeholder="What you looking for..."
            value={searchQuery}
            onChange={handleSearchChange}
            style={{
              width: "100%",
              maxWidth: 400,
              padding: "6px 10px",
              borderRadius: 4,
            }}
          />
        </div>

        {searchQuery.trim() !== "" && (
          <div
            className="product-thumbnails1"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
              overflowX: "auto",
              padding: "10px 0",
              maxWidth: "100%",
            }}
          >
            {filteredImages.map((image, index) => (
              <div
                key={index}
                className="thumbnail"
                style={{ cursor: "pointer", position: "relative" }}
                onClick={() => handleThumbnailClick(image)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <img
                  id={`img-${index}`}
                  src={image.src || image.main}
                  alt={image.name || "Product image"}
                  style={{
                    maxWidth: 100,
                    maxHeight: 100,
                    objectFit: "contain",
                    borderRadius: 5,
                  }}
                />
                {hoveredIndex === index && image.name && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      color: "#fff",
                      fontSize: 12,
                      padding: "2px 4px",
                      borderBottomLeftRadius: 5,
                      borderBottomRightRadius: 5,
                    }}
                  >
                    {image.name}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedThumbnailMain && (
        <div
          style={{
            marginTop: 10,
            fontSize: 14,
            color: "darkgreen",
            wordBreak: "break-all",
          }}
        >
          Main image path: {selectedThumbnailMain}
          <div>Id: {ActualId}</div>
        </div>
      )}
      <div
        ref={mockupRef}
        style={{
          width: "100%",
          maxWidth: 1000,
          position: "relative",
          marginBottom: 20,
          overflow: "hidden",
        }}
      >
        {backgroundImage && (
          <img
            src={backgroundImage}
            alt="mockup background"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />
        )}

        {overlayImage && (
          <ResizableImage2
            src={overlayImage}
            initialPosition={{ x: 115, y: 130 }}
            initialSize={{ width: 500, height: 500 }}
            color="red"
            sendMessage={(data) => console.log("Overlay size info:", data)}
          />
        )}
      </div>

      <button
        onClick={handleUploadToCloudinary}
        disabled={uploading}
        style={{
          padding: "10px 20px",
          backgroundColor: uploading ? "gray" : "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: uploading ? "not-allowed" : "pointer",
        }}
      >
        {uploading ? "Uploading..." : "Save to Cloudinary"}
      </button>

      {/* Cloudinary link */}
      {cloudinaryUrl && (
        <div style={{ marginTop: 20 }}>
          <a
            href={cloudinaryUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#007bff",
              textDecoration: "underline",
              fontWeight: "bold",
            }}
          >
            View Uploaded Image on Cloudinary
          </a>
        </div>
      )}
      {/* Download CSV */}
      {styleNumber && selectedColor && (
        <button
          onClick={downloadCSV}
          style={{
            marginTop: 20,
            padding: "10px 20px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Download CSV for {styleNumber} - {selectedColor}
        </button>
      )}
    </div>
  );
};

export default MockupUploader;
